var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("entity-reader", {
        attrs: {
          entity: "encounter",
          id: _vm.id,
          "api-name": "encounters",
          "use-sharing": true,
          "allow-copy": true,
          "home-route-name": "encounterTimeTable"
        },
        on: { approve: _vm.handleApprove },
        scopedSlots: _vm._u(
          [
            {
              key: `reader`,
              fn: function({ doc }) {
                return [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("label-value", {
                            attrs: {
                              name: "Event/Day/Time",
                              value: _vm.getEventDayTime(doc),
                              "name-cols": "4",
                              "value-cols": "8"
                            }
                          }),
                          _c("label-value", {
                            attrs: {
                              name: "Encounter Type",
                              value: doc.encounterTypeText,
                              "name-cols": "4",
                              "value-cols": "8"
                            }
                          }),
                          _c("label-value", {
                            attrs: {
                              name: "Priority",
                              value: doc.priorityText,
                              "name-cols": "4",
                              "value-cols": "8"
                            }
                          }),
                          _c("label-value", {
                            attrs: {
                              name: "Ref Cover Needed",
                              value: doc.refCoverText,
                              "name-cols": "4",
                              "value-cols": "8"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                        _c("span", { staticClass: "font-weight-medium" }, [
                          _vm._v("Tags")
                        ]),
                        _c(
                          "div",
                          { staticClass: "mt-2" },
                          _vm._l(doc.tags, function(tag, i) {
                            return _c(
                              "v-chip",
                              { key: i, staticClass: "mr-2 px-4" },
                              [_vm._v(" " + _vm._s(tag) + " ")]
                            )
                          }),
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12", sm: "2" } }, [
                        _c("span", { staticClass: "font-weight-medium" }, [
                          _vm._v("Plot")
                        ])
                      ]),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "10" } },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                to: {
                                  name: "readPlot",
                                  params: { id: doc.plotKeyId }
                                },
                                title: doc.plotName
                              }
                            },
                            [_vm._v(" " + _vm._s(doc.plotName) + " ")]
                          ),
                          _c("approval-status", {
                            attrs: { status: doc.plotStatus }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("label-value", {
                    attrs: { name: "Name", value: doc.name }
                  }),
                  _c("label-value", {
                    attrs: { name: "Inbound", value: _vm.getInbound(doc) }
                  }),
                  _c("label-value", {
                    attrs: { name: "Outbound", value: _vm.getOutbound(doc) }
                  }),
                  _c("label-value", {
                    attrs: { name: "Description", value: doc.description }
                  }),
                  _c("label-value", {
                    attrs: {
                      name: "Costume Level",
                      value: doc.costumeLevelText
                    }
                  }),
                  _c("label-value", {
                    attrs: { name: "Costume Notes", value: doc.costumeNotes }
                  }),
                  _c("label-value", {
                    attrs: { name: "Makeup Level", value: doc.makeupLevelText }
                  }),
                  _c("label-value", {
                    attrs: { name: "Makeup", value: doc.makeupNotes }
                  }),
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12", sm: "2" } }, [
                        _c("span", { staticClass: "font-weight-medium" }, [
                          _vm._v("Monsters")
                        ])
                      ]),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "10" } },
                        [
                          _c(
                            "v-expansion-panels",
                            {
                              attrs: { accordion: "", flat: "", outlined: "" }
                            },
                            _vm._l(doc.monsters, function(monster, i) {
                              return _c(
                                "v-expansion-panel",
                                { key: i },
                                [
                                  _c("v-expansion-panel-header", [
                                    _c(
                                      "span",
                                      [
                                        _c("span", { staticClass: "mr-2" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(monster.minQuantity) +
                                              " - " +
                                              _vm._s(monster.maxQuantity) +
                                              " x " +
                                              _vm._s(monster.stats.name) +
                                              " "
                                          )
                                        ]),
                                        _c("approval-status", {
                                          attrs: {
                                            status: monster.stats.statusId
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c("monster-summary", {
                                        attrs: { monster: monster.stats }
                                      }),
                                      monster.notes
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-medium"
                                              },
                                              [_vm._v("Notes:")]
                                            ),
                                            _vm._v(
                                              " " + _vm._s(monster.notes) + " "
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "900" },
          model: {
            value: _vm.showApprovalFailureDialog,
            callback: function($$v) {
              _vm.showApprovalFailureDialog = $$v
            },
            expression: "showApprovalFailureDialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { tile: "", "data-card": "" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "warning" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", "data-close": "" },
                      on: {
                        click: function($event) {
                          _vm.showApprovalFailureDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Cannot Approve Encounter")])
                ],
                1
              ),
              _c("v-card-text", { staticClass: "text-h6" }, [
                _vm._v(" The following things are not approved "),
                _c(
                  "ul",
                  _vm._l(_vm.approvalValidation, function(val, i) {
                    return _c("li", { key: i }, [
                      _vm._v(" " + _vm._s(val) + " ")
                    ])
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }